/* ------------------------- External Dependencies -------------------------- */
import React from 'react'
import styled from 'styled-components'
import MediaQuery from 'react-responsive'
/* ------------------------- Internal Dependencies -------------------------- */
import assets from 'assets'
import { 
  Flex, Box, 
  BackgroundImage, BackgroundGradient,
  Button, Container, Heading, Image, Link, Paragraph, Section, Span, SVG,
  Blockquote, HorizontalRule, Shape, Responsive 
}from 'atomic'
import { CommunityPrograms } from 'workshop/blocks'
import {
  Actions,
  FrontIntroduction,
  FrontJourney,
  FrontPrograms,
  FrontTrustTheTrustless,
  FrontWebRTC,
  FrontDetect,
  FrontNavigateTheWorld,
  FrontTrustTheBlockchain,
} from 'workshop/sections'
import { ButtonLink } from 'fusion'
import {
  FormResourceURL
} from 'workshop/forms'
import {
  WalletAddress
} from 'foundry'
/* --------------------------- Styled Components ---------------------------- */

const BoxPerspective = styled(Flex)`
  perspective: 1120px;

  & > div:nth-of-type(2) {
    transform: rotateY(30deg);
  }
`

/* ------------------------- Component Properties --------------------------- */
/* ------------------------------- Component -------------------------------- */
export default props=> (
<div>
<Section {...props} px={[20]} bg='red' color='white' pos='relative' textAlign='center' z={20} >
  <Shape top left right h={[ '70px', '90px', "85px"]} mt={['-70px', '-90px', '-85px']} svg={assets.svg.waves} w={[1]} />
  <Shape top bottm right h={[ '70px', '90px', "85px"]} svg={assets.svg.waves} w={[1]} transform={['rotate(180deg)']} />
</Section>
<FrontIntroduction/>
<FrontWebRTC/>
<FrontTrustTheTrustless/>
<FrontDetect/>
<FrontNavigateTheWorld/>
<FrontTrustTheBlockchain/>

</div>)


// WEBPACK FOOTER //
// ./src/interface/workshop/pages/main/Front/index.js